import { transformSDKFloatToRESTFloat } from '@wix/sdk-runtime/transformations/float';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixLoyaltyCheckoutexchangeV1LoyaltyCheckoutExchangeUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'api._api_base_domain_': [
      {
        srcPath: '/loyalty-checkout-exchange',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/_api/loyalty-checkout-exchange',
        destPath: '',
      },
      {
        srcPath: '/loyalty-checkout-exchange',
        destPath: '',
      },
    ],
    'bo._base_domain_': [
      {
        srcPath: '/loyalty-checkout-exchange',
        destPath: '',
      },
    ],
    'wixbo.ai': [
      {
        srcPath: '/loyalty-checkout-exchange',
        destPath: '',
      },
    ],
    'wix-bo.com': [
      {
        srcPath: '/loyalty-checkout-exchange',
        destPath: '',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/loyalty-checkout-exchange',
        destPath: '',
      },
      {
        srcPath: '/_api/loyalty-checkout-exchange',
        destPath: '/api',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/loyalty-checkout-exchange',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/loyalty-checkout-exchange',
        destPath: '',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/loyalty-checkout-exchange',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_loyalty_checkout-exchange';

/**
 * Applies a discount to a checkout.
 *
 * You can apply one of the following discounts, which are exchanged for loyalty points: `reward`, `loyaltyCoupon`, or `referralReward`.
 */
export function applyDiscountToCheckout(
  payload: object
): RequestOptionsFactory<any> {
  function __applyDiscountToCheckout({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.loyalty.checkoutexchange.v1.loyalty_checkout_discount',
      method: 'POST' as any,
      methodFqn:
        'wix.loyalty.checkoutexchange.v1.LoyaltyCheckoutExchange.ApplyDiscountToCheckout',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixLoyaltyCheckoutexchangeV1LoyaltyCheckoutExchangeUrl({
        protoPath: '/v1/loyalty-checkout-discount',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __applyDiscountToCheckout;
}

/**
 * Creates a query to retrieve a list of checkout discounts.
 *
 * The `queryLoyaltyCheckoutDiscount()` method builds a query to retrieve a list of checkout discounts and returns a `LoyaltyCheckoutDiscountQueryBuilder` object.
 *
 * The returned object contains the query definition, which is typically used to run the query using the `find()` method.
 *
 * You can refine the query by chaining `LoyaltyCheckoutDiscountQueryBuilder` methods onto the query. `LoyaltyCheckoutDiscountQueryBuilder` methods enable you to sort, filter, and control the results `queryLoyaltyCheckoutDiscount()` returns.
 *
 * `queryLoyaltyCheckoutDiscount()` runs with these `LoyaltyCheckoutDiscountQueryBuilder` defaults, which you can override:
 *
 * - `limit(50)`
 * - `descending("_createdDate")`
 *
 * The methods that are chained to `queryLoyaltyCheckoutDiscount()` are applied in the order they're called. For example, if you apply ascending('status') and then descending('checkoutId'), the results are sorted first by the status, and then, if there are multiple results with the same status, the items are sorted by checkout ID.
 */
export function queryLoyaltyCheckoutDiscounts(
  payload: object
): RequestOptionsFactory<any> {
  function __queryLoyaltyCheckoutDiscounts({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'query.sort.origin.latitude' },
          { path: 'query.sort.origin.longitude' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.loyalty.checkoutexchange.v1.loyalty_checkout_discount',
      method: 'POST' as any,
      methodFqn:
        'wix.loyalty.checkoutexchange.v1.LoyaltyCheckoutExchange.QueryLoyaltyCheckoutDiscounts',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixLoyaltyCheckoutexchangeV1LoyaltyCheckoutExchangeUrl({
        protoPath: '/v1/loyalty-checkout-discounts/query',
        data: serializedData,
        host,
      }),
      data: serializedData,
    };

    return metadata;
  }

  return __queryLoyaltyCheckoutDiscounts;
}
